import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';

import {
  AssignmentManagementDisplayMode,
  setDataGridSelectedRange,
  setFilterDrivers,
  setFilterVehicles,
} from './assignmentManagement.slice';

export const AssignmentManagementClearFiltersButton = () => {
  const dispatch = useAppDispatch();
  const displayMode = useAppSelector(
    (state) => state.assignmentManagement.displayMode
  );

  const filterDrivers = useAppSelector(
    (state) => state.assignmentManagement.filterDrivers
  );
  const filterVehicles = useAppSelector(
    (state) => state.assignmentManagement.filterVehicles
  );
  const dataGridSelectedRange = useAppSelector(
    (state) => state.assignmentManagement.dataGridSelectedRange
  );

  const showClearFiltersButton = !!(
    (filterDrivers.length || filterVehicles.length || dataGridSelectedRange) &&
    displayMode === AssignmentManagementDisplayMode.DATAGRID
  );

  if (!showClearFiltersButton) {
    return null;
  }

  return (
    <Button
      variant="anchor"
      onClick={() => {
        dispatch(setFilterDrivers([]));
        dispatch(setFilterVehicles([]));
        dispatch(setDataGridSelectedRange(undefined));
      }}
      dataTestId="assignment-management-clear-filters-button"
    >
      Clear Filters
    </Button>
  );
};
